import React, { useState } from 'react';
import { Button } from '../../ui/Button';
import { ContactPicker } from './ContactPicker';
import { followUpService } from '../../../services/followUpService';
import { followUpAiService } from '../../../services/followUpAiService';

const field = 'w-full rounded-xl border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-meetoi-navy';
const todayIso = () => new Date().toLocaleDateString('en-CA');

const shift = (iso, days) => {
  const d = new Date(`${iso}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
};

// Suggests a day a week before the deadline or event (when still ahead), else the date itself.
const suggestDay = (finding) => {
  const target = finding.deadline_date || finding.event_date;
  if (!target) return '';
  const early = shift(target, -7);
  if (early >= todayIso()) return early;
  return target >= todayIso() ? target : '';
};

export const FindingFollowUp = ({ userId, watch, finding, contacts, onContactAdded, onSaved, onCancel }) => {
  const [contactId, setContactId] = useState(watch.contact_id || '');
  const [day, setDay] = useState(suggestDay(finding));
  const [note, setNote] = useState(`${watch.title}: ${finding.title}`.slice(0, 300));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const createContact = async (name) => {
    const created = await followUpAiService.createContact(userId, name);
    onContactAdded(created);
    setContactId(created.id);
  };

  const save = async () => {
    if (saving || !contactId || !day || !note.trim()) return;
    setSaving(true);
    setError('');
    try {
      await followUpService.create({
        userId,
        contactId,
        day,
        note: `${note.trim()} (${finding.source_url})`.slice(0, 500),
        momentId: watch.moment_id,
        source: 'ai_suggestion'
      });
      onSaved();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="mt-3 space-y-3 rounded-xl border border-violet-200 bg-violet-50/50 p-3">
      <p className="text-xs text-slate-600">
        Review this reminder. Nothing is saved until you click Save. Follow-ups are about a person, so choose one.
      </p>
      <div className="text-xs font-medium text-slate-600">Who
        <ContactPicker contacts={contacts} value={contactId} onChange={setContactId} candidateIds={[]} personName="" onCreate={createContact} />
      </div>
      <label className="block text-xs font-medium text-slate-600">When
        <input type="date" className={`${field} mt-1`} value={day} min={todayIso()} onChange={(e) => setDay(e.target.value)} />
      </label>
      {!day && <p className="text-xs text-amber-700">The source gave no usable future date. Please choose one.</p>}
      <label className="block text-xs font-medium text-slate-600">What
        <input className={`${field} mt-1`} value={note} maxLength={300} onChange={(e) => setNote(e.target.value)} />
      </label>
      {error && <p className="text-xs font-medium text-red-600">{error}</p>}
      <div className="flex gap-2">
        <Button size="sm" onClick={save} isLoading={saving} disabled={!contactId || !day || !note.trim()}>Save follow-up</Button>
        <Button size="sm" variant="secondary" onClick={onCancel} disabled={saving}>Cancel</Button>
      </div>
    </div>
  );
};